export default __webpack_public_path__ + "static/media/hero-wpa-1440x600.a8142d1d.jpg";